import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'reroute-rules',
})

export default class RerouteRules extends Vue {

    // ----------------------------------------------------------------
    // Properties

    @Prop()
    private suggestedItems: any;

    private rerouteRules: any = [
        {
            name: 'ECpA Rules',
            keyName: 'ecpa-rule',
            contents: ['Rule 1 [w1]', 'Rule 6[w6]', 'Rule 8 [w8]'],
        },
        {
            name: 'Principles of Learning',
            keyName: 'principle',
            contents: ['P1', 'P3', 'P8'],
        },
        {
            name: 'Resource Score & Ranking',
            keyName: 'resource',
            contents: [
                {
                    name: 'Web resource',
                    count: 0.8,
                },
                {
                    name: 'Audio resource',
                    count: 0.6,
                },
                {
                    name: 'Video resource',
                    count: 0.5,
                },
                {
                    name: 'Text resource',
                    count: 0.7,
                },
            ],
        },

    ];

    @Watch('suggestedItems')
    private onChangeSuggestion() {
        this.onLoadRules();
    }

    // ---------------------------------------------------------------
    // Hooks

    private created() {
        this.onLoadRules();
    }

    // ---------------------------------------------------------------
    // Methods

    private onLoadRules() {
        const suggestedItems = this.suggestedItems;
        const resourceItems: any = [];
        const ruleItems: any = [];
        suggestedItems.forEach((item: any) => {
            const contents = item.contents || [];
            const resouceContent = contents[0];
            const title = resouceContent ? resouceContent.title : item.title;
            let label = resouceContent ? resouceContent.subFormat : item.format;
            label = label.split('_').join(' ');
            const resource = {
                score: item.score.toFixed(2),
                label,
                format: item.format,
                title,
            };
            ruleItems.push(item.actionId);
            resourceItems.push(resource);
        });
        const resourceMenu = this.rerouteRules.find((item: any) => item.keyName === 'resource');
        const ecpaMenu = this.rerouteRules.find((item: any) => item.keyName === 'ecpa-rule');
        resourceMenu.contents = resourceItems;
        ecpaMenu.contents = ruleItems;
    }

}
